<template>
  <v-container fluid class="py-0">
    <v-alert v-if="error" type="error" dismissible>
      {{ error }}
    </v-alert>
    <v-row>
      <v-col lg="12">
        <v-card class="card-shadow px-4 py-4 overflow-hidden border-radius-xl">
          <v-row>
            <v-col cols="auto">
              <v-avatar width="74" height="74" class="shadow border-radius-lg">
                <v-icon size="40">mdi-domain</v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="auto" class="my-auto">
              <div class="h-100">
                <h5 class="mb-1 text-h5 text-typo font-weight-bold">
                  {{ companyData.company_name }}
                </h5>
                <p class="mb-0 font-weight-bold text-body text-sm">
                  {{ companyData.contact_city }},
                  {{ companyData.contact_region }}
                </p>
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="my-auto">
              <v-btn
                v-if="company"
                @click="goBack"
                elevation="0"
                :ripple="false"
                height="43"
                class="
                  font-weight-bold
                  text-capitalize
                  btn-primary
                  bg-gradient-default
                  py-3
                  px-6
                "
              >
                <v-icon size="18">mdi-arrow-left</v-icon>
                回公司列表
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-tabs
          v-model="activeTab"
          background-color="transparent"
          class="text-left"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab :ripple="false" href="#tab-1">
            <span class="ms-1">公司資料</span>
          </v-tab>
          <v-tab :ripple="false" href="#tab-2">
            <span class="ms-1">打卡設定</span>
          </v-tab>
          <v-tab :ripple="false" href="#tab-3">
            <span class="ms-1">員工列表</span>
          </v-tab>
          <v-tab :ripple="false" href="#tab-4">
            <span class="ms-1">員工排班</span>
          </v-tab>
          <v-tab :ripple="false" href="#tab-5">
            <span class="ms-1">排班資訊</span>
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="12">
        <v-tabs-items v-model="activeTab" :key="companyId || 'company-profile'">
          <v-tab-item value="tab-1">
            <company-basic-info-widget
              :company-data="companyData"
              @save="(payload, done) => onChildSave('basic', payload, done)"
            ></company-basic-info-widget>
            <company-contact-info-widget
              :company-data="companyData"
              @save="(payload, done) => onChildSave('contact', payload, done)"
            ></company-contact-info-widget>
            <company-financial-info-widget
              :company-data="companyData"
              @save="(payload, done) => onChildSave('financial', payload, done)"
            ></company-financial-info-widget>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <company-clock-setting-list
              :company-id="companyId"
              ref="companyClockSettingList"
            ></company-clock-setting-list>
          </v-tab-item>
          <v-tab-item value="tab-3">
            <div v-if="!showUserProfile">
              <users-list @view-user="viewUserProfile"></users-list>
            </div>
            <div v-else>
              <user-profile
                :user-id="selectedUserId"
                @back="backToUsersList"
              ></user-profile>
            </div>
          </v-tab-item>
          <v-tab-item value="tab-4">
            <employee-clock-settings
              :company-id="companyId"
              ref="employeeClockSettings"
            ></employee-clock-settings>
          </v-tab-item>
          <v-tab-item value="tab-5">
            <company-scheduling-info
              ref="companySchedulingInfo"
              :company-id="companyId"
            ></company-scheduling-info>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <!-- Progress Dialog -->
    <progress-dialog :visible="loading" message="載入中，請稍候..." />
  </v-container>
</template>
<script>
import CompanyBasicInfoWidget from "./Widgets/ProfileWidgets/CompanyBasicInfoWidget.vue";
import CompanyContactInfoWidget from "./Widgets/ProfileWidgets/CompanyContactInfoWidget.vue";
import CompanyFinancialInfoWidget from "./Widgets/ProfileWidgets/CompanyFinancialInfoWidget.vue";
import CompanyClockSettingList from "./Widgets/ProfileWidgets/CompanyClockSettingList.vue";
import EmployeeClockSettings from "./Widgets/ProfileWidgets/EmployeeClockSettings.vue";
import CompanySchedulingInfo from "./Widgets/ProfileWidgets/CompanySchedulingInfo.vue";
import UsersList from "../Users/UsersList.vue";
import UserProfile from "../Users/UserProfile.vue";
import ProgressDialog from "@/components/Common/ProgressDialog.vue";
import { mapGetters } from "vuex";
export default {
  name: "CompanyProfile",
  props: {
    company: {
      type: Object,
      required: false,
      default: null,
    },
  },
  components: {
    CompanyBasicInfoWidget,
    CompanyContactInfoWidget,
    CompanyFinancialInfoWidget,
    CompanyClockSettingList,
    EmployeeClockSettings,
    CompanySchedulingInfo,
    UsersList,
    UserProfile,
    ProgressDialog,
  },
  data() {
    return {
      companyData: {},
      loading: false,
      error: null,
      companyId: null,
      activeTab: "tab-1",
      selectedUserId: null,
      showUserProfile: false,
      hasUpdates: false,
    };
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    company_id() {
      return this.selectedCompany ? this.selectedCompany.id : null;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    // Get company ID from selectedCompany, prop, or route params
    this.companyId = this.company_id;
    console.log("Company ID:", this.companyId);
    if (!this.companyId && this.company && this.company.id) {
      this.companyId = this.company.id;
    } else if (!this.companyId && this.$route.params.id) {
      this.companyId = parseInt(this.$route.params.id);
    }
    if (!this.companyId) {
      this.error = "無法取得公司 ID";
      return;
    }
    this.fetchCompanyProfile();
  },
  watch: {
    selectedCompany: {
      handler(newCompany) {
        const nextCompanyId = newCompany ? Number(newCompany.id) : null;
        if (!nextCompanyId || nextCompanyId === Number(this.companyId)) {
          return;
        }

        this.companyId = nextCompanyId;
        this.selectedUserId = null;
        this.showUserProfile = false;
        this.hasUpdates = false;
        this.fetchCompanyProfile();
      },
    },
    activeTab: {
      immediate: true,
      handler(newValue) {
        if (newValue === "tab-2") {
          this.refreshCompanyClockSettings();
        } else if (newValue === "tab-3") {
          this.refreshUsersList();
        } else if (newValue === "tab-4") {
          this.refreshEmployeeClockSettings();
        } else if (newValue === "tab-5") {
          this.$nextTick(() => {
            const component = this.$refs.companySchedulingInfo;
            if (component && typeof component.fetchSchedules === "function") {
              component.fetchSchedules();
            } else {
              console.log(
                "Component not found or fetchSchedules method not found"
              );
            }
          });
        }
      },
    },
  },
  methods: {
    async fetchCompanyProfile() {
      this.loading = true;
      this.error = null;
      try {
        // Get company data from API
        const response = await this.$axios.get(
          `/api/companies/${this.companyId}`
        );
        // Store the response data
        this.companyData = response.data;
        // console.log("Company data loaded:", this.companyData);
      } catch (err) {
        console.error("Error fetching company profile:", err);
        this.error = "無法載入公司資料";
      } finally {
        this.loading = false;
      }
    },
    async savePartial(payload) {
      try {
        const res = await this.$axios.put(
          `/api/companies/${this.companyId}`,
          payload
        );
        // Refresh local data with latest server state
        await this.fetchCompanyProfile();
        return { ok: true, data: res.data };
      } catch (err) {
        console.error("Error saving partial company data:", err);
        if (err.response && err.response.data && err.response.data.error) {
          const error_msg = err.response.data.error;
          alert(error_msg);
        }
        return { ok: false, error: err };
      }
    },
    onChildSave(section, payload, done) {
      this.savePartial(payload).then((result) => {
        if (result.ok) {
          this.hasUpdates = true;
        }
        done && done(result.ok);
      });
    },
    goBack() {
      // If used as a component with props, emit event
      if (this.company) {
        this.$emit("onClose", this.hasUpdates);
      } else {
        // If used as a route, navigate back to company list
        // Pass update flag via query param or store if needed, but for now simple navigation
        this.$router.push("/pages/users/company");
      }
    },
    viewUserProfile(userId) {
      this.selectedUserId = userId;
      this.showUserProfile = true;
    },
    backToUsersList() {
      this.showUserProfile = false;
      this.selectedUserId = null;
    },
    refreshUsersList() {
      this.$root && this.$root.$emit("refresh-users-data");
    },
    refreshCompanyClockSettings() {
      this.$nextTick(() => {
        const component = this.$refs.companyClockSettingList;
        if (component && typeof component.fetchClockSettings === "function") {
          component.fetchClockSettings();
        }
      });
    },
    refreshEmployeeClockSettings() {
      this.$nextTick(() => {
        const component = this.$refs.employeeClockSettings;
        if (
          component &&
          typeof component.fetchEmployeeClockSettings === "function"
        ) {
          component.fetchEmployeeClockSettings();
        }
      });
    },
  },
};
</script>
